<template>
  <kst-section items-mode class="mt-5">
    <kst-table input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="ItemID"
        :label="StockReductionItemCatalog.DispatchName.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="StockReductionItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo_Details(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging-small"
        field="Packaging"
        :label="StockReductionItemCatalog.Packaging.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="StockReductionItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="Qty"
        :label="StockReductionItemCatalog.Qty.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="StockReductionItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="StockReductionItemCatalog.SellPrice.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="StockReductionItemCatalog"
        />
      </b-table-column>

      <template v-if="data.SpecialPriceCount > 0">
        <b-table-column
          v-slot="{ column, row }"
          cell-class="ks-col-specialprice-button"
          field="SpecialPriceID"
          :label="StockReductionItemCatalog.SpecialPriceID.Label"
        >
          <kst-output field-only
            :field="column.field" :data="row" :catalog="StockReductionItemCatalog"
          />
        </b-table-column>

        <b-table-column numeric
          v-slot="{ column, row }"
          cell-class="ks-col-price"
          field="SellPriceNetto"
          :label="StockReductionItemCatalog.SellPriceNetto.Label"
        >
          <kst-output box-off field-only
            :field="column.field" :data="row" :catalog="StockReductionItemCatalog"
          />
        </b-table-column>
      </template>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Total"
        :label="StockReductionItemCatalog.Total.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="StockReductionItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import Model from "../StockReductionModel.js";
import StockReductionItemCatalog from "../StockReductionItemCatalog.js";

export default {
  props: {
    data: Object,
    items: Array
  },
  data: () => ({
    Model: Model,
    StockReductionItemCatalog: StockReductionItemCatalog
  })
}
</script>